import React from "react";
import styles from "../../styles/modal.module.css";
import { modalType } from "../../types/modal";
import QRModal from "./QRModal";
import PrivacyPolicyModal from "./PrivacyPolicyModal";
import SessionWarningModal from "./SessionWarningModal";
import OnExitModal from "./OnExitModal";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  type: string;
  actions: {
    continue:() => void;
    isAccepted?:boolean
  };
}

const Modal = React.memo(({ isOpen, onClose, type, actions }: IProps) => {
  if (!isOpen) return null;
  const renderModalContent = () => {
    switch (type) {
      case `${modalType.QR_CODE}`:
        return <QRModal onClose={onClose} actions={actions}/>
      case `${modalType.PRIVACY_POLICY}`:
        return <PrivacyPolicyModal onClose={onClose} actions={actions}/>
      case `${modalType.SESSION_WARNING}`:
        return <SessionWarningModal onClose={onClose}/>
      case `${modalType.ON_EXIT}`:
        return <OnExitModal onClose={onClose} actions={actions}/>
      default:  
        return null;
    }
  };

  return <div className={styles.modalOverlay}>{renderModalContent()}</div>;
});

export default Modal;
